var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import objectPath from 'object-path';
import { ControlType } from './api';
export function clone(value) {
    return JSON.parse(JSON.stringify(value));
}
export function isSame(a, b) {
    return JSON.stringify(a) == JSON.stringify(b);
}
export function isElementInDom(element) {
    var parent = element;
    while (parent != null) {
        if (parent == document.body) {
            return true;
        }
        parent = parent.parentElement;
    }
    return false;
}
export function isElementChildOf(element, targetParent) {
    var parent = element;
    while (parent != null) {
        if (parent == targetParent) {
            return true;
        }
        parent = parent.parentElement;
    }
    return false;
}
export function assign(target, source) {
    target = target || {};
    Object.keys(source).forEach(function (name) {
        if (!target[name]) {
            target[name] = source[name];
        }
    });
    return target;
}
export function stringIsNullOrEmpty(str) {
    var s = str == null ? '' : str.toString().trim();
    return s == '';
}
export function compilePattern(pattern, record, locale) {
    if (pattern == null) {
        return pattern;
    }
    // TODO: encoded by server
    pattern = pattern.replace(/\%7B/mgi, '{');
    pattern = pattern.replace(/\%7D/mgi, '}');
    pattern = pattern.replace(/\%24/mgi, '$');
    var replaced = pattern;
    if (replaced.startsWith('{') &&
        replaced.endsWith('}') &&
        (replaced.match(/\{/g) || []).length == 1) {
        var path = replaced.substring(1, replaced.length - 1);
        return objectPath.get(record, path);
    }
    if (locale) {
        replaced = replaced.replace(/\{\{\{([^\{}]*)\}\}\}/g, function (n, match) {
            var x = objectPath.get(record, match);
            var a = (x !== undefined && x !== null ? x : '');
            return locale.translate(a);
        });
        replaced = replaced.replace(/\{\{([^\{}]*)\}\}/g, function (n, match) { return locale.translate(match); });
    }
    replaced = replaced.replace(/\{([^\{}]*)\}/g, function (n, match) {
        var x = objectPath.get(record, match);
        var a = (x !== undefined && x !== null ? x : '');
        return a;
    });
    return (!replaced ? null : replaced);
}
export function compileObject(target, data, locale) {
    if (target == null) {
        return null;
    }
    Object.keys(target)
        .forEach(function (key) {
        var value = target[key];
        if (typeof value == 'string') {
            if (value.match(/^\{[^\{\}]*\}$/)) {
                var path = value.replace('{', '').replace('}', '');
                target[key] = objectPath.get(data, path);
            }
            else {
                target[key] = compilePattern(value, data, locale);
            }
        }
        else {
            target[key] = compileObject(value, data, locale);
        }
    });
    return target;
}
export function compilePatchOperations(operations, record, locale) {
    return operations
        .map(function (op) {
        if (op.value) {
            return __assign(__assign({}, op), { value: compilePattern(op.value, record, locale) });
        }
        else {
            return op;
        }
    });
}
export function handleValueMap(value, valueMap) {
    return (valueMap ? valueMap[value] || value : value);
}
export function getControlValueText(control, value, locale) {
    if (control.kind == ControlType.Select) {
        var select_1 = control;
        if (select_1.multiple) {
            return value.map(function (v) { return compilePattern(select_1.itemLabelPattern, v, locale); }).join(', ');
        }
        else {
            return compilePattern(select_1.itemLabelPattern, value, locale);
        }
    }
    else if (control.kind == ControlType.Scan) {
        var scan = control;
        return (value ? compilePattern(scan.itemLabelPattern, value, locale) : null);
    }
    else {
        return value;
    }
}
//# sourceMappingURL=util.js.map